module.exports = __webpack_public_path__ + "img/atom.4ee75662.svg";